import type { ListItemType, ListProps } from './List.types';
import { BasicList } from './components/BasicList';
import { SortableList } from './components/SortableList';

/**
 * A wrapper component that manages the rendering of either a sortable or regular list based on the provided props.
 */
const List = <T extends ListItemType>(props: ListProps<T>) => {
  if (props.sortable) {
    return <SortableList {...props} />;
  }

  return <BasicList {...props} />;
}

export default List;
